// 20.1.2.4 Number.isNaN(number)
var $export = require('./_export');

$export($export.S, 'Number', {
  isNaN: function isNaN(number){
    return number != number;
  }
});


//////////////////
// WEBPACK FOOTER
// /home/artur/workspace/vscode/warpriders/~/core-js/modules/es6.number.is-nan.js
// module id = ../../../../core-js/modules/es6.number.is-nan.js
// module chunks = 0